import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import {connect} from "react-redux";
import { patchSocialLink } from 'redux/social/actions';

import onClickOutside from "react-onclickoutside";
import Parser from 'html-react-parser';

import InputField from 'components/elements/InputField';

import './SocialLinkCustomLabel.css';

const ENTER_KEY = 13;


class SocialLinkCustomLabel extends Component {
  static propTypes = {
    patchSocialLink: PropTypes.func.isRequired,
    location: PropTypes.object,
    item: PropTypes.object.isRequired,
    patchSocialLinkError: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    patchSocialLinkError: null,
    me: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    this.setState({
      initialValue: this.props.item.custom_label ?
        this.props.item.custom_label : this.props.item.social_network.form_label,
      currentValue: this.props.item.custom_label ?
        this.props.item.custom_label : this.props.item.social_network.form_label,
    });

    if (this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item.custom_label !== this.props.item.custom_label) {
      this.setState({ currentValue: this.props.item.custom_label });
    }

    if (prevProps.location !== this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeInputValue = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('custom_label', currentValue);
      this.props.patchSocialLink(this.props.item.id, form);
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeInputValue();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeInputValue();
  };

  executeValidation = () => {
    const { patchSocialLinkError } = this.props;
    const { currentValue } = this.state;

    if (patchSocialLinkError) {
      if (patchSocialLinkError.custom_label) {
        return patchSocialLinkError.custom_label;
      }
      if (patchSocialLinkError.non_field_errors) {
        return patchSocialLinkError.non_field_errors[0];
      }
    }
    if (currentValue === '' ) {
      return i18n.t("Link label should not be empty");
    }
    if (currentValue && currentValue.length > 64) {
      return i18n.t("Ensure this field has no more than 64 characters");
    }
    return null;
  };

  render() {
    const { me, item } = this.props;
    const { currentValue } = this.state;

    return (

      <div className="social-link-custom-label__component">
        <div className="social-icon">{Parser(item.social_network.icon_svg)}</div>
        <div className="input-wrapper">
          <InputField
            value={currentValue}
            onChange={(e) => {
              e.preventDefault();
              this.setState({ currentValue: e.target.value });
            }}
            customRef={this.inputEditFieldRef}
            error={this.executeValidation() && {text: this.executeValidation()}}
            disabled={me && me.subscription && !me.subscription.ff_social_links_custom_label}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchSocialLinkError: state.socialReducer.patchSocialLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchSocialLink,
  },
)(onClickOutside(SocialLinkCustomLabel));
